export default "__VITE_ASSET__rMxiHGS8__"